import styled from 'styled-components';

export const StyledInteractiveVideoPlayer = styled.div`
  width: 100%;
  height: 100%;
  max-height: var(--appheight) !important;
  z-index: 1;
`;
